import { AppRegistry } from "react-native";
import App from "digiwash-customer/App";

AppRegistry.registerComponent("digiwash", () => App);
AppRegistry.runApplication("digiwash", {
  rootTag: document.getElementById("root"),
});
